import { render, staticRenderFns } from "./PurchaseOrderList.vue?vue&type=template&id=6733d8c1&scoped=true"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderList.vue?vue&type=style&index=0&id=6733d8c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6733d8c1",
  null
  
)

export default component.exports